import { Link } from "react-router-dom";
import { Fragment } from "react";
import { PhotographCredit, responsivePhotographProps } from "@/components/LicensedPhotograph";
import { PageMeta } from "@/components/PageMeta";
import { formatPublicationDate, getReadTime, researchArticles } from "@/content/researchArticles";

export default function ResearchPage() {
  return <><PageMeta title="Company Research | FU Research" description="Independent company research from FU Research on enduring businesses, industry structure, competitive advantage and long-term value creation." path="/research" /><div className="inner-page shell" data-testid="research-page">
    <header className="inner-hero research-index-hero">
      <p className="eyebrow" data-testid="research-page-label">FU Research / Research</p>
      <div className="inner-title-grid">
        <h1 data-motion="title" data-testid="research-page-title">Independent inquiry into enduring businesses.</h1>
        <p data-motion="metadata" data-testid="research-page-introduction">Company research grounded in primary sources, careful context and a long-term view of value creation.</p>
      </div>
    </header>

    <section className="featured-research" data-motion="body" data-testid="featured-research-section">
      <div className="featured-research-heading" data-testid="featured-research-heading">
        <p className="eyebrow" data-testid="featured-research-label">Latest Company Research</p>
        <p data-testid="featured-research-count">{String(researchArticles.length).padStart(2, "0")} / {String(researchArticles.length).padStart(2, "0")}</p>
      </div>
      <div className="publication-list" data-testid="company-research-publication-list">
        {researchArticles.map((article, index) => <Fragment key={article.slug}><Link className="publication-card" to={article.path} data-testid={`research-article-card-${article.slug}`}>
          <div className="publication-image-wrap" data-testid={`research-card-image-container-${article.slug}`}>
            <img src={article.hero.src} alt={article.hero.alt} {...responsivePhotographProps(article.hero, "(max-width: 767px) 88px, 340px")} style={{ objectFit: article.hero.cardFit, objectPosition: article.hero.position }} data-testid={`research-card-image-${article.slug}`} />
          </div>
          <div className="publication-card-copy">
            <div className="publication-meta" data-testid={`research-card-meta-${article.slug}`}>
              <span>{String(index + 1).padStart(2, "0")} · {article.category}{article.topic ? ` · ${article.topic}` : ""} · {article.author}</span>
              <span>{formatPublicationDate(article.publishedAt)} · {getReadTime(article)}</span>
            </div>
            <h2 data-testid={`research-card-title-${article.slug}`}>{article.title}</h2>
            <p data-testid={`research-card-summary-${article.slug}`}>{article.summary}</p>
            <span className="publication-read-link" data-testid={`research-card-read-label-${article.slug}`}>Read research <b aria-hidden="true">↗</b></span>
          </div>
        </Link><PhotographCredit photo={article.hero} testId={`research-photo-credit-${article.slug}`} /></Fragment>)}
      </div>
    </section>

    <section className="research-index-areas" data-motion="body" data-testid="research-index-areas-section">
      <p className="eyebrow" data-testid="research-index-areas-label">Areas of inquiry</p>
      <ol>
        {["Company Research", "Industry Structure", "Competitive Advantage", "Original Essays"].map((category, index) => <li key={category} data-testid={`research-index-category-${index + 1}`}><span>0{index + 1}</span><h2>{category}</h2></li>)}
      </ol>
    </section>
  </div></>;
}